import React from "react";
import Grid from "@material-ui/core/Grid";
import { GlobalHotKeys } from "react-hotkeys";
import CardButton from "../CardButton";
import StringFormat from "../../../../util/string-format";
import BaseKeyListener from "../listeners/BaseKeyListener";

const BooleanSelector = ({
	selected,
	onSelected,
	onSkip,
	disableKeyListener,
	yesLabel = "Yes",
	noLabel = "No"
}) => {
	const items = [
		{ code: true, name: yesLabel, keyStroke: "y" },
		{ code: false, name: noLabel, keyStroke: "n" }
	];

	return (
		<Grid container spacing={1} justifyContent="flex-start">
			{items.map((item) => (
				<Grid item xs={12} sm={3} key={String(item.code)}>
					<CardButton
						size="small"
						textAlign="center"
						text={
							<span>
								{StringFormat.formatTextWithKeystroke(item.name, item.keyStroke)}
							</span>
						}
						onClick={() => onSelected(item.code)}
						active={selected === item.code}
						id={item.name.toLowerCase().replace(" ", "-")}
					/>
				</Grid>
			))}
			<Grid item xs={12}>
				{!disableKeyListener && (
					<>
						<BaseKeyListener
							items={items}
							onSelected={(item) => onSelected(item.code)}
						/>
						{onSkip && (
							<GlobalHotKeys
								keyMap={{ SKIP: ["tab"] }}
								handlers={{
									SKIP: (e) => {
										e.preventDefault();
										if (selected !== undefined) {
											onSkip(selected);
										}
									}
								}}
								allowChanges
							/>
						)}
					</>
				)}
			</Grid>
		</Grid>
	);
};

export default BooleanSelector;
